import styled from 'styled-components';

export const Key = styled.span`
  color: ${props => props.theme.palette.text.light};
  font-size: ${props => props.theme.typography.sizes.body1};
  display: inline-flex;
  gap: 0.5rem;
`;
